import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import Footer from './Footer'

const Mainfol = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
  return (
    <div className='flex flex-1 h-screen'>
      <div className=' lg:w-64'>
        <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen}/>
      </div>
      <div className=' flex lg:w-[80%] w-full flex-col'>
        <Header className='' isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen}/>
        <div className='px-5 lg:px-10 pt-20 mx-auto w-full mb-5'>
          <Outlet />
        </div>
        <Footer/>
      </div>
    </div>
  )
}

export default Mainfol